import { Theme } from '@mui/material/styles';

import { deepNavy } from '../../palette-v2';

// ----------------------------------------------------------------------

export function paper(_theme: Theme) {
  return {
    MuiPaper: {
      styleOverrides: {
        root: {
          backgroundImage: 'none',
        },
        outlined: {
          borderColor: deepNavy[200],
        },
      },
    },
  };
}
